const ELLIPSIS = "ellipsis";

/**
 * Builds page numbers: active page, next 3 pages, ellipsis, last page.
 * Example (page 5 of 10): [5, 6, 7, 8, "ellipsis", 10]
 * Example (page 1 of 10): [1, 2, 3, 4, "ellipsis", 10]
 */
export const getPaginationRange = (currentPage, totalPages) => {
  if (!totalPages || totalPages < 1) return [];
  if (totalPages === 1) return [1];

  const pageSet = new Set([currentPage, totalPages]);

  for (let i = 1; i <= 3; i++) {
    const nextPage = currentPage + i;
    if (nextPage <= totalPages) {
      pageSet.add(nextPage);
    }
  }

  const sorted = [...pageSet].sort((a, b) => a - b);

  if (sorted.length === totalPages) {
    return sorted;
  }

  const result = [];
  for (let i = 0; i < sorted.length; i++) {
    if (i > 0 && sorted[i] - sorted[i - 1] > 1) {
      result.push(ELLIPSIS);
    }
    result.push(sorted[i]);
  }

  return result;
};

export { ELLIPSIS };
